import React from 'react';
import {Skeleton} from '../../../../../../common/components/Skeleton/Skeleton';
import {SkeletonSection} from '../../../../../../common/components/Skeleton/SkeletonSection/SkeletonSection';
import {SkeletonRow} from '../../../../../../common/components/Skeleton/SkeletonRow/SkeletonRow';
import {SkeletonLineWrapper} from '../../../../../../common/components/Skeleton/SkeletonLine/SkeletonLineWrapper';
import {classes} from './TopCheckoutButtonSkeleton.st.css';

export enum TopCheckoutButtonSkeletonDataHook {
  Root = 'TopCheckoutButtonSkeleton.Root',
}

export const TopCheckoutButtonSkeleton = () => {
  return (
    <Skeleton dataHook={TopCheckoutButtonSkeletonDataHook.Root}>
      <SkeletonSection>
        <SkeletonRow>
          <SkeletonLineWrapper className={classes.topCheckoutButtonSkeleton} />
        </SkeletonRow>
      </SkeletonSection>
    </Skeleton>
  );
};
